<template>
    <van-sticky>
        <van-row class="headpro">
            <van-col span="24">
               {{ $t('prolist.pagetitle') }}
            </van-col>
        </van-row>
    </van-sticky>
</template>

<script>
    export default {
        name: "Headpro"
    }
</script>

<style scoped>
    .headpro{
        overflow: hidden;
        height: 0;
        width: 100%;
        padding-bottom: 10%;
        font-size: 16px;
        font-weight: bold;
        line-height: 38px;
        color: #333;
        background: white;
    }
</style>
